module.exports = __webpack_public_path__ + "media/images/iconDown__errorRed--dark-affc8b20fde4cd0bebf66b27c31e95cd.png";